import { createUseStyles } from "react-jss";

export default createUseStyles({
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    backdropFilter: "blur(5px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
  },
  modalContainer: {
    position: "relative",
    width: "90%",
    maxWidth: "1000px",
    height: "auto",
    maxHeight: "85vh",
    overflowY: "auto",
    backgroundColor: "#0f0f0f",
    border:"0.5px solid #bbb",
    borderRadius: "16px",
    boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
    overflow: "hidden",
  },
  closeButton: {
    position: "absolute",
    top: "16px",
    right: "16px",
    background: "transparent",
    border: "none",
    color: "#bbb",
    cursor: "pointer",
    zIndex: 10,
    padding: "8px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "background 0.2s, color 0.2s",
    "&:hover": {
      backgroundColor: "#f3f4f6",
      color: "#111827",
    },
  },
  layout: {
    display: "flex",
    flexDirection: "row",
    height: "100%",
    maxHeight: "85vh",
    "@media (max-width: 768px)": {
      flexDirection: "column",
      gap:20
    },
  },
  imageSection: {
    position: "relative",
    "@media (max-width: 768px)": {
      flex: "none",
      height: "250px",
    },
  },
  image: {
    width: "100%",
    height: "100%",
    maxHeight:300,
    maxWidth:300,
    borderRadius:48,
    padding:20
  },
  typeBadge: {
    position: "absolute",
    top: "12px",
    left: "12px",
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    color: "#fff",
    padding: "6px 12px",
    borderRadius: "20px",
    fontSize: "12px",
    fontWeight: "bold",
    letterSpacing: "1px",
  },
  contentSection: {
    flex: "1 1 50%",
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    maxHeight: "100%",
    "@media (max-width: 768px)": {
      padding: "12px",
    },
  },
  title: {
    fontSize: "32px",
    fontWeight: "800",
    color: "#ffffff",
    margin: "0 0 16px 0",
  },
  descriptionArea: {
    flexGrow: 1,
    overflowY: "auto",
    paddingRight: "10px",
    marginBottom: "24px",
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: "10px",
    },
  },
  description: {
    fontSize: "16px",
    lineHeight: "1.7",
    color: "#bababa",
    margin: 0,
    whiteSpace: "pre-line",
  },
  buttonContainer: {
    display: "flex",
    gap: "16px",
    marginTop: "auto",
    "@media (max-width: 768px)": {
      flexDirection: "column",
    },
    
  },
  button: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    padding: "14px 24px",
    borderRadius: "8px",
    fontSize: "15px",
    fontWeight: "600",
    textDecoration: "none",
    transition: "all 0.2s",
  },
  primaryButton: {
    backgroundColor: "#8a8a8a",
    color: "#ffffff",
    border: "2px solid #111827",
    "&:hover": {
      backgroundColor: "#4affa4",
          color: "#000",

    },
  },
  secondaryButton: {
    backgroundColor: "transparent",
    color: "#8a8a8a",
    border: "2px solid #8a8a8a",
    "&:hover": {
      borderColor: "#000",
      color: "#000",
      backgroundColor: "#4affa4",
    },
  },
  disabled: {
    opacity: 0.2,
    pointerEvents: "none",
    cursor: "not-allowed",
    filter: "grayscale(100%)",
  },
});